import { useLocalStorage } from "@solana/wallet-adapter-react";
import request from "../api/request";
import { ScannedWalletData } from "../api/types";

const PrizeWalletStatus = () => {
  let [authorization, setAuthorization] = useLocalStorage<string[]>('authorization', ['authorization', '']);
  let [walletStatus, setWalletStatus] = request<ScannedWalletData[]>('/wallet/prize-wallet-status', {headers: [authorization], method: 'get'}, true);

  return (
    <pre className="Admin-wallet-status-counts">{JSON.stringify(walletStatus, undefined, 2)}</pre>
  )
}

export default PrizeWalletStatus;